import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetValues =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;
      let link = UrlApi.values.get + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteValues =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.values.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageValues =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      }
      if (
        values?.media &&
        values?.media != null &&
        values?.media != undefined &&
        CheckImageIsFile({ data: values?.media, IsBoolean: true })
      ) {
        bodyFormData.append("media", values?.media);
      } else if (editMode && !values?.media) {
        bodyFormData.append("media", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.values.edit}/${paramID}`
          : UrlApi.values.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditValues =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.values.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
